import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { BookingRestrictionValidation } from 'uplisting-frontend/validations';

export default class BookingRestrictionRepositoryService extends BaseRepositoryService<
  ModelRegistry['booking-restriction']
> {
  recordName = 'booking-restriction';
  implementMethods = ['buildChangeset', 'createRecord'];

  validation = BookingRestrictionValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/booking-restriction': BookingRestrictionRepositoryService;
  }
}
